import SvgIcon from "@mui/material/SvgIcon";

import { CircleArrowProps } from "./CircleArrowUp";
import { circleArrowSvgIconStyles } from "./CircleSvgIcon.styles";

const CircleArrowLeft = (props: CircleArrowProps): JSX.Element => {
  return (
    <SvgIcon
      sx={{
        ...circleArrowSvgIconStyles.sx,
        pointerEvents: props.disabled ? "none" : "auto",
        cursor: props.disabled ? "not-allowed" : "pointer",
        opacity: props.disabled ? 0.5 : 1,
      }}
      fill="none"
      {...props}
    >
      <circle cx="12" cy="12" r="10" strokeWidth="1.5" />
      <path
        d="M13.5 9L10.5 12L13.5 15"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default CircleArrowLeft;
